import React from "react"

function Heading1({ heading, subheading }) {
  return (
    <div className="container pt-1 d-flex flex-column align-items-center heading1">
      <div className="Heading display-2 text-purple d-flex align-items-center lh-md pb-2">
        <div style={{ letterSpacing: "3px" }}>{heading}</div>
      </div>
      <div className="subHeading ps-1 text-uppercase text-gray d-flex align-items-center lh-1">
        <div>{subheading}</div>
      </div>
    </div>
  )
}

export default Heading1
